import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const HeaderWrapper = styled.div`
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
`;

export const HeaderText = styled(Typography.TextH3_24_34)(
    ({ theme: { palette } }) => css`
        color: ${palette.neutral.white};
    `,
);

export const ActionsWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    @media (max-width: 1439px) {
        max-width: 900px;
    }

    @media (max-width: 1300px) {
        max-width: 800px;
    }

    @media (max-width: 1100px) {
        max-width: 600px;
    }
`;

export const Ornament = styled.div`
    bottom: 0px;
    display: flex;
    position: absolute;
    right: 42px;
`;
